import React from 'react';
import { connect } from 'react-redux';
import DescriptionCampaign from '@/containers/CampaignDetail/Description/Description';
import Notes from '@/containers/SubCampaignDetail/Notes/Notes';
import { TABS } from '@/helpers/constants';
import { getIsVANCR } from '@/redux/Campaign/campaign.reducer';
import { setSubCampaignDescriptionNotes, setSubCampaignOriginalValues } from '@/redux/SubCampaign/subCampaign.action';
import { getSubcampaignDescriptionNotes, getSubCampaignOriginalValues } from '@/redux/SubCampaign/subCampaign.reducer';
import { OriginalValues } from '@/types';

type DescriptionProps = {
  setDescriptionNotes: (notes: string[]) => void;
  setOriginalValues: (values: OriginalValues) => void;
  originalValues: OriginalValues;
  descriptionNotes: string[];
  isVANCR: boolean;
};

const Description = (props: DescriptionProps) => {
  const { setDescriptionNotes, setOriginalValues, originalValues, descriptionNotes, isVANCR } = props;

  const addNotes = () => {
    setDescriptionNotes([...descriptionNotes, '']);
  };

  const onSetOriginValues = () => {
    const values = {
      ...originalValues,
      hasChange: true,
    };
    setOriginalValues(values);
  };

  const handleChangeText = (comment: string, id: number) => {
    const newState = [...descriptionNotes];
    newState.splice(id, 1, comment);
    setDescriptionNotes(newState);
    onSetOriginValues();
  };

  return (
    <>
      <DescriptionCampaign subCR />
      {!isVANCR
        && (<Notes notes={descriptionNotes} addNotes={addNotes} handleChangeText={handleChangeText} tab={TABS.description.label} />)}
    </>
  );
};

const mapStateToProps = (state) => ({
  descriptionNotes: getSubcampaignDescriptionNotes(state),
  originalValues: getSubCampaignOriginalValues(state),
  isVANCR: getIsVANCR(state),
});

const actionCreators = {
  setDescriptionNotes: setSubCampaignDescriptionNotes,
  setOriginalValues: setSubCampaignOriginalValues,
};

export default connect(mapStateToProps, actionCreators)(Description);
